import React from "react"
import "./layout.scss"

import Header from './header/header'
import Footer from './footer/footer'
import WhatsappFloat from '../components/whatsapp-float/whatsapp-float'


const Layout = ({ className, headerProps, footerProps, children }) => {
  return (
    <>
      <div className={className}>
        <Header properties={headerProps}></Header>
        {children}
        <Footer properties={footerProps}></Footer>
      </div>
      <WhatsappFloat />
    </>
  )
}

export default Layout